export const previewSectionsTestIds = {
  gridPreview: 'grid-preview',
  block: (blockId: string) => `test_${blockId}`,
};
